import { Component, ReactNode } from 'react';

// UI
import Button from '@components/button';

// styles
import css from './styles.module.css';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

const RELOAD_DELAY = 3000;

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error('Chunk loading failed:', error);

    console.log(error.message);

    if (
      error.message.includes('Loading chunk') ||
      error.message.includes('Failed to load')
    ) {
      setTimeout(() => window.location.reload(), RELOAD_DELAY);
    }
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className={css.container}>
          <h3 className={css.title}>Something went wrong</h3>
          <p className={css.text}>
            An unexpected error has occurred. Try refreshing the page.
          </p>
          <Button className={css.btn} onClick={this.handleReload} size="large">
            Reload Page
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
